import React from 'react';
import { DefinitionGrid, type DefinitionGridItem } from '../../common/DefinitionGrid';

interface MetadataSectionProps {
  title: string;
  icon?: React.ReactNode;
  /** Confidence pill rendered inline after the title. */
  badge?: React.ReactNode;
  rows: DefinitionGridItem[];
  className?: string;
}

/** One labelled block of the metadata panel: heading row plus its value rows. */
export const MetadataSection: React.FC<MetadataSectionProps> = ({
  title,
  icon,
  badge,
  rows,
  className,
}) => (
  <div className={className}>
    <div className="mb-1 flex items-center gap-1">
      {icon}
      <span className="revy-cjk text-xs font-semibold leading-[1.5] text-muted-foreground">
        {title}
      </span>
      {badge}
    </div>
    <DefinitionGrid items={rows} labelWidth="45%" className="gap-x-2 gap-y-[3px] text-xs" />
  </div>
);
